import NamedDto from 'modules/base/dto/NamedDto';

export class UserGroupEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {number[]} */
		this.fejezetek = null;
	}

	/**
	 * @typedef {Object} _UserGroupEditDtoProps
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _UserGroupEditDtoProps} UserGroupEditDtoProps
	 */
	/**
	 *
	 * @param {UserGroupEditDtoProps} props
	 * @returns {UserGroupEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.fejezetek = props.fejezetek;

		return this;
	}
}

export default UserGroupEditDto;
